import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum ELocationScoreActionTypes {
  SetRating = 'NEW_REVIEW/LOCATION/SET',
}

type TSetLocationScore = ITypedReduxAction<ELocationScoreActionTypes.SetRating, number>;

export const setLocationScore: (rating: number) => TSetLocationScore = actionGenerator<
  ELocationScoreActionTypes.SetRating,
  number
>(ELocationScoreActionTypes.SetRating);

export type TLocationScore = TSetLocationScore;
